/* Kolab: exact search.
   Shopify's storefront search is fuzzy: a made up word still returns results.
   Quoting each word turns it into an exact match, so "drole" only brings the
   Drôle de Monsieur pieces. When the exact search finds nothing, the shopper is
   sent to the loose search instead, with a note, so a typo still gets results. */
(() => {
  const SEARCH = '/search';
  const path = () => {
    const seg = location.pathname.split('/').filter(Boolean);
    return (seg.length && seg[0].length <= 5 && seg[0].includes('-') === false && seg[0] !== 'search' && /^[a-z]{2}(-[a-z]{2})?$/i.test(seg[0])) ? '/' + seg[0] + SEARCH : SEARCH;
  };
const BRANDS = {"a p c": "a-p-c","a.p.c.": "a-p-c","adidas": "adidas","air jordan": "air-jordan","ami": "ami","apc": "a-p-c","asics": "asics","birkenstock": "birckenstock","books": "books","cactus": "cactus-jack-by-travis-scott","cactus jack by travis scott": "cactus-jack-by-travis-scott","chimi": "chimi","converse": "converse","corteiz": "corteiz","drole": "drole-de-monsieur","drole de monsieur": "drole-de-monsieur","filling": "filling-pieces","filling pieces": "filling-pieces","found": "found","havaianas": "havaianas","jacquemus": "jacquemus","jordan": "air-jordan","kidsuper": "kidsuper","kolab": "kolab","maison": "maison-mihara-yasuhiro","maison mihara yasuhiro": "maison-mihara-yasuhiro","new balance": "new-balance","nike": "nike","on": "on","pdf": "pdf","pdf channel": "pdf","piet": "piet","salomon": "salomon","saucony": "saucony","son is son": "son-is-son","stussy": "stussy","supreme": "supreme","taschen": "taschen","two jeys": "two-jeys","twojeys": "two-jeys","ugg": "ugg","unknown": "unknown","vans": "vans","yzy": "yzy"};
  const plain = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
  const brandOf = (raw) => BRANDS[plain(raw)] || null;
  const prefix = () => {
    const seg = location.pathname.split('/').filter(Boolean)[0] || '';
    return /^[a-z]{2}(-[a-z]{2})?$/i.test(seg) && seg !== 'search' ? '/' + seg : '';
  };
  const quote = (raw) => {
    const terms = (raw || '').replace(/["“”]/g, ' ').trim().split(/\s+/).filter(Boolean);
    if (!terms.length) return '';
    return terms.map((t) => (t.length > 1 ? '"' + t + '"' : t)).join(' ');
  };

  // 1. Every search form sends the exact version of what was typed.
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/search"]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    if (input.dataset.kolabDone === input.value) return;
    const brand = brandOf(input.value);
    if (brand) {
      // A brand name shows the whole brand, not just the pieces with it in the title.
      event.preventDefault();
      location.href = prefix() + '/collections/' + brand + '?kolab_brand=' + encodeURIComponent(input.value.trim());
      return;
    }
    const exact = quote(input.value);
    if (!exact) return;
    input.dataset.kolabRaw = input.value.replace(/["“”]/g, ' ').trim();
    input.dataset.kolabDone = exact;
    input.value = exact;
    let keep = form.querySelector('input[name="kolab_q"]');
    if (!keep) { keep = document.createElement('input'); keep.type = 'hidden'; keep.name = 'kolab_q'; form.appendChild(keep); }
    keep.value = input.dataset.kolabRaw;
  }, true);

  // 2. On the results page: show what was typed, and fall back when it finds nothing.
  const params = new URLSearchParams(location.search);
  const brandParam = params.get('kolab_brand');
  if (brandParam) {
    const note = {
      pt: 'A mostrar toda a marca. Ver resultados da pesquisa por "T".',
      es: 'Mostrando toda la marca. Ver resultados de la búsqueda de "T".',
      fr: 'Toute la marque est affichée. Voir les résultats de recherche pour "T".',
      it: 'Mostriamo tutto il marchio. Vedi i risultati della ricerca per "T".',
      de: 'Die ganze Marke wird gezeigt. Suchergebnisse für "T" ansehen.',
      nl: 'Het hele merk wordt getoond. Bekijk de zoekresultaten voor "T".',
      da: 'Hele mærket vises. Se søgeresultater for "T".',
      nb: 'Hele merket vises. Se søkeresultater for "T".',
      pl: 'Pokazujemy całą markę. Zobacz wyniki wyszukiwania dla "T".',
      sv: 'Hela varumärket visas. Se sökresultat för "T".',
      en: 'Showing the whole brand. See search results for "T".',
    };
    const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    const show = () => {
      const anchor = document.querySelector('[data-facets-form-content="products-list"]') || document.querySelector('main');
      if (!anchor || document.querySelector('.kolab-brand-note')) return;
      const p = document.createElement('p');
      p.className = 'kolab-brand-note';
      p.style.cssText = 'margin:0 var(--space-3, 16px) var(--space-2, 12px);color:#6c6e65;font-size:1.2rem';
      const txt = (note[lang] || note.en).split('T');
      p.append(txt[0]);
      const a = document.createElement('a');
      a.href = prefix() + '/search?q=' + encodeURIComponent(brandParam) + '&kolab_q=' + encodeURIComponent(brandParam) + '&kolab_loose=1';
      a.textContent = brandParam;
      a.style.cssText = 'color:inherit;text-decoration:underline';
      p.append(a, txt[1] || '');
      anchor.parentNode.insertBefore(p, anchor);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show);
    else show();
  }
  const typed = params.get('kolab_q');
  const q = params.get('q') || '';
  if (!q) return;
  if (!params.get('kolab_loose')) {
    const brand = brandOf(q.replace(/"/g, ' '));
    if (brand) { location.replace(prefix() + '/collections/' + brand + '?kolab_brand=' + encodeURIComponent(q.replace(/"/g, ' ').trim())); return; }
  }
  // The shopper should never see the quotes we added.
  if (q.includes('"')) {
    const clean = typed || q.replace(/"/g, '').trim();
    const tidy = () => {
      if (document.title.includes(q)) document.title = document.title.split(q).join(clean);
      document.querySelectorAll('h1, h2, .empty, .title').forEach((el) => {
        if (el.children.length === 0 && el.textContent.includes(q)) el.textContent = el.textContent.split(q).join(clean);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidy);
    else tidy();
  }
  document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach((i) => {
    if (typed) i.value = typed;
    else if (q.includes('"')) i.value = q.replace(/"/g, '').trim();
  });
  if (params.get('kolab_loose')) {
    // Came from an exact search that found nothing: say so, quietly.
    const note = {
      pt: 'Sem resultados exatos para "T". A mostrar resultados aproximados.',
      es: 'Sin resultados exactos para "T". Mostrando resultados aproximados.',
      fr: 'Aucun résultat exact pour "T". Voici des résultats approchants.',
      it: 'Nessun risultato esatto per "T". Mostriamo risultati simili.',
      de: 'Keine genauen Treffer für "T". Wir zeigen ähnliche Ergebnisse.',
      nl: 'Geen exacte resultaten voor "T". We tonen vergelijkbare resultaten.',
      da: 'Ingen præcise resultater for "T". Viser lignende resultater.',
      nb: 'Ingen nøyaktige treff for "T". Viser lignende resultater.',
      pl: 'Brak dokładnych wyników dla "T". Pokazujemy podobne wyniki.',
      sv: 'Inga exakta träffar för "T". Visar liknande resultat.',
      en: 'No exact matches for "T". Showing close results.',
    };
    const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    const show = () => {
      const anchor = document.querySelector('.product-list') || document.querySelector('main');
      if (!anchor || document.querySelector('.kolab-loose-note')) return;
      const el = document.createElement('p');
      el.className = 'kolab-loose-note';
      el.style.cssText = 'margin:0 var(--space-3, 16px) var(--space-2, 12px);color:#6c6e65;font-size:1.2rem';
      el.textContent = (note[lang] || note.en).replace('T', q);
      anchor.parentNode.insertBefore(el, anchor);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', show);
    else show();
    return;
  }
  if (!q.includes('"')) {
    // A link straight to the loose search, for instance from Google: redo it exactly.
    const exact = quote(q);
    if (!exact || exact === q) return;
    const strict = new URLSearchParams(location.search);
    strict.set('q', exact);
    strict.set('kolab_q', q);
    location.replace(path() + '?' + strict.toString());
    return;
  }
  const ready = () => {
    // Look only at the results list: .empty also belongs to the cart drawer.
    const list = document.querySelector('[data-facets-form-content="products-list"]');
    if (!list || list.querySelector('a[href*="/products/"]')) return;
    const loose = new URLSearchParams(location.search);
    loose.set('q', typed || q.replace(/"/g, '').trim());
    loose.set('kolab_loose', '1');
    location.replace(path() + '?' + loose.toString());
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
